<template>
  <van-popup v-model="popShow" :close-on-click-overlay="false" position="bottom">
    <div ref="popupRef" class="set_payment_code_popup">
      <img :class="$store.state.isMirroring && 'mirror'" class="close" src="@/assets/close.png" @click="closePopup" />
      <div class="sub_container" v-show="curStep === 1">
        <div v-show="showSlideVerification" id="slideVerification2" class="slide_verification"></div>
        <div v-show="popShow && !showSlideVerification">
          <div class="title">{{ title }}</div>
          <div class="account">
            {{ verifyType === 'EMAIL' ? $store.state.userInfo.email : '+' + $store.state.userInfo.phone }}
          </div>
          <CommonInput
            v-model="smsCode"
            type="tel"
            inputmode="numeric"
            :placeholder="verifyType == 'PHONE' ? $t('common.smsCode') : $t('common.emailCode')"
            theme="white"
            :max-length="VALID_CODE_LENGTH"
            auto-focus
          >
            <div class="send_span" :class="msgValidating && 'disabled'" @touchend.stop.prevent="resend">
              {{ !msgValidating ? (firstSendMsg ? $t('common.send') : $t('common.resend')) : this.count + 's' }}
            </div>
          </CommonInput>
          <CommonBtn class="next_btn" :text="$t('common.next')" :disabled="!smsCode" :on-click="nextStep" />
          <div
            v-show="verifyType !== 'EMAIL' && emailBtnShow"
            class="switch_verify_type"
            @click="() => changeVerifyType('EMAIL')"
          >
            {{ $t('loginAndRegister.verifyEmail') }}
          </div>
          <div
            v-show="verifyType !== 'PHONE' && phoneBtnShow"
            class="switch_verify_type"
            @click="() => changeVerifyType('PHONE')"
          >
            {{ $t('loginAndRegister.verifyPhone') }}
          </div>
        </div>
      </div>
      <div class="sub_container" v-show="curStep === 2">
        <div class="title">{{ $t('redesign.resetPwd') }}</div>
        <div class="account">
          {{ verifyType === 'EMAIL' ? $store.state.userInfo.email : '+' + $store.state.userInfo.phone }}
        </div>
        <!-- 输入密码 -->
        <CommonInput
          v-model="password"
          theme="white"
          :type="showPassword ? 'text' : 'password'"
          :placeholder="$t('loginAndRegister.pwdPlaceholder')"
          show-clear
          auto-focus
          :on-focus="focusPasswordInput"
          :on-blur="inputBlur"
        >
          <img
            v-show="!showPassword"
            class="password_status_icon"
            src="@/assets/password_hidden.png"
            @touchend.stop.prevent="showPassword = !showPassword"
          />
          <img
            v-show="showPassword"
            class="password_status_icon"
            src="@/assets/password_visible.png"
            @touchend.stop.prevent="showPassword = !showPassword"
          />
        </CommonInput>
        <div v-show="passwordWarning" class="country_toast">
          <img class="note_icon" src="@/assets/note_icon.png" alt="" />
          {{ $t('loginAndRegister.pwdNote') }}
        </div>
        <!-- 再次输入 -->
        <CommonInput
          class="pwd_input"
          v-model="confirmPassword"
          theme="white"
          :type="showSecondPassword ? 'text' : 'password'"
          :placeholder="$t('loginAndRegister.reenterPwdPlaceholder')"
          show-clear
          :on-focus="focusPasswordInput"
        >
          <img
            v-show="!showSecondPassword"
            class="password_status_icon"
            src="@/assets/password_hidden.png"
            @touchend.stop.prevent="showSecondPassword = !showSecondPassword"
          />
          <img
            v-show="showSecondPassword"
            class="password_status_icon"
            src="@/assets/password_visible.png"
            @touchend.stop.prevent="showSecondPassword = !showSecondPassword"
          />
        </CommonInput>
        <div v-show="confirmPassword" class="country_toast">
          <img class="note_icon" src="@/assets/note_icon.png" alt="" />
          {{ $t('loginAndRegister.reenterPwdNote') }}
        </div>
        <CommonBtn class="next_btn" :text="$t('common.done')" :disabled="!canNext" :on-click="setPassword" />
      </div>
    </div>
  </van-popup>
</template>

<script>
import CommonInput from '@/components/CommonInput'
import CommonBtn from '@/components/CommonBtn'
import { Toast } from 'vant'
import md5 from 'js-md5'
import throttle from 'lodash/throttle'
import { isInWebView } from '@/utils'
import { VALID_CODE_LENGTH } from '@/utils/constants'

export default {
  name: 'PasswordSetPopup',
  components: {
    CommonInput,
    CommonBtn
  },
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      VALID_CODE_LENGTH,
      firstLoad: true,
      popShow: this.value,
      curStep: 1, // 1: 验证阶段 2: 设置密码
      verifyType: 'EMAIL', // 验证方式
      showSlideVerification: false,
      smsCode: '',
      firstSendMsg: true,
      interval: undefined,
      msgValidating: false,
      count: 59,
      password: '',
      confirmPassword: '',
      showPassword: false,
      showSecondPassword: false,
      passwordWarning: false,
      passwordError: false,
      areaCode: '',
      canNext: false,
      toWhatsapp: false
    }
  },
  computed: {
    emailBtnShow() {
      return !!this.$store.state.userInfo.email
    },
    phoneBtnShow() {
      return !!this.$store.state.userInfo.phone
    },
    title() {
      return this.verifyType === 'EMAIL'
        ? this.$t('redesign.sendToEmail')
        : this.toWhatsapp
          ? this.$t('redesign.sendToWhatsapp')
          : this.$t('redesign.sendToPhone')
    }
  },
  watch: {
    value(val) {
      this.popShow = val
      if (val) {
        if (this.firstLoad) {
          this.firstLoad = false
          this.initSlideVerification()
        }
        this.curStep = 1
        this.smsCode = ''
        this.password = ''
        this.confirmPassword = ''
        this.showPassword = false
        this.showSecondPassword = false
        this.passwordWarning = false
        this.passwordError = false
        this.canNext = false
        this.showSlideVerification = false
        this.msgValidating = false
        this.count = 59
        this.firstSendMsg = true
        this.interval && clearInterval(this.interval)
        if (this.$store.state.userInfo.email) {
          this.verifyType = 'EMAIL'
          this.sendSmsCode()
        } else {
          this.verifyType = 'PHONE'
          this.showSlideVerification = true
        }
        if (isInWebView()) {
          document.addEventListener('touchstart', this.checkInputFocus)
          this.checkInputFocus()
        }
      } else {
        if (isInWebView()) {
          document.removeEventListener('touchstart', this.checkInputFocus)
        }
      }
    },
    popShow(val) {
      this.$emit('input', val)
    },
    password() {
      this.change()
    },
    confirmPassword() {
      this.change()
    },
    smsCode(val) {
      if (val.length === this.VALID_CODE_LENGTH) {
        this.nextStep()
      }
    }
  },
  mounted() {
    this.getAreaCodes()
  },
  methods: {
    checkInputFocus() {
      setTimeout(() => {
        if (document.activeElement.tagName === 'INPUT') {
          this.$refs.popupRef.style.paddingBottom = '35vh'
        } else {
          this.$refs.popupRef.style.paddingBottom = '0.24rem'
        }
      }, 200)
    },
    initSlideVerification() {
      const $this = this
      initSMCaptcha(
        {
          organization: '90I5YRBCdvRoD8mXmETq',
          domains: ['captcha-xjp.fengkongcloud.cn'], // 新加坡
          product: 'embed', // 展现形式
          appendTo: 'slideVerification2', // 指定 DOM 节点
          mode: 'slide', // 验证码模式
          lang: 'en',
          width: 295,
          style: {
            slideBar: {
              color: '#3FBB70',
              successColor: '#3FBB70',
              border: 'none',
              process: {
                background: '#3FBB7033',
                failBackground: '#ff4c6233'
              },
              button: {
                boxShadow: 'none',
                background: '#3FBB70',
                failBackground: '#ff4c62'
              }
            }
          }
        },
        (SMCaptcha) => {
          SMCaptcha.onSuccess(function (data) {
            if (data.pass) {
              $this.showSlideVerification = false
              SMCaptcha.reset()
              $this.sendSmsCode(data.rid)
            }
          })
        }
      )
    },
    changeVerifyType(type) {
      this.verifyType = type
      if (type === 'PHONE') {
        this.showSlideVerification = true
        clearInterval(this.interval)
        this.msgValidating = false
        this.count = 59
        this.smsCode = ''
      } else if (type === 'EMAIL') {
        this.showSlideVerification = false
        clearInterval(this.interval)
        this.msgValidating = false
        this.count = 59
        this.sendSmsCode()
        this.smsCode = ''
      }
    },
    async getAreaCodes() {
      const $this = this
      const countryNo = this.$store.state.userInfo.countryNo
      await this.$http
        .get(window.serverPath + '/api/country/getAreaCodes', { cache: true })
        .then(function (res) {
          if (res.data && res.data.code === '200' && res.data.data) {
            res.data.data.forEach((each) => {
              if (each.countryNo === countryNo) {
                $this.areaCode = each.areaCode
              }
            })
          }
        })
        .catch((_err) => {
          console.log('err')
        })
    },
    resend() {
      if (this.msgValidating) {
        return
      }
      this.smsCode = ''
      if (this.verifyType === 'EMAIL') {
        this.sendSmsCode()
      } else {
        this.showSlideVerification = true
      }
    },
    async sendSmsCode(rid = '') {
      if (this.msgValidating) {
        return
      }
      if (!this.areaCode) {
        await this.getAreaCodes()
      }
      let isEmail = this.verifyType === 'EMAIL'
      const $this = this
      const phone = this.$store.state.userInfo.phone
      const email = this.$store.state.userInfo.email
      const url =
        window.serverPath +
        (isEmail ? '/api/auth/getNewEmailCode/RESET_LOGIN_PASSWORD' : '/api/auth/getNewSmsCode/RESET_LOGIN_PASSWORD')
      let params = isEmail
        ? {
            email: email
          }
        : {
            phone: phone,
            areaCode: this.areaCode,
            rid: rid
          }
      if (phone || email) {
        this.$http
          .post(url, params)
          .then((res) => {
            if (res.data.code === '200') {
              $this.msgValidating = true
              $this.firstSendMsg = false
              $this.toWhatsapp = res.data.data === 'WhatsApp'
              $this.interval = window.setInterval(() => {
                $this.count -= 1
                if ($this.count <= 0) {
                  clearInterval($this.interval)
                  $this.msgValidating = false
                  $this.count = 59
                }
              }, 1000)
            } else if (res.data.code === '60001') {
              Toast({
                message: this.$t('loginAndRegister.userExistToast')
              })
            } else {
              Toast({
                message: res.data.message
              })
            }
          })
          .catch((_err) => {
            console.log('异常')
            $this.msgValidating = false
            $this.count = 59
          })
      }
    },
    nextStep: throttle(
      function () {
        if (!this.smsCode) {
          Toast({ message: this.$t('loginAndRegister.verificationCodeEmptyToast') })
          return
        }
        const params = {}
        if (this.verifyType === 'EMAIL') {
          params.email = this.$store.state.userInfo.email
        } else {
          params.phone = this.$store.state.userInfo.phone
        }
        params.validCode = this.smsCode
        let url =
          this.verifyType === 'EMAIL'
            ? '/api/auth/checkEmailCode/RESET_LOGIN_PASSWORD'
            : '/api/auth/checkSmsCode/RESET_LOGIN_PASSWORD'
        this.$http
          .post(window.serverPath + url, params)
          .then((res) => {
            if (res.data.code === '200') {
              this.curStep = 2 // 验证成功，进入下一步
              this.$store.commit('setSecurityToken', res.data.data.securityToken)
            } else {
              Toast({
                message: this.$t('accountSecurity.wrongCodeToast')
              })
            }
          })
          .catch((_err) => {
            console.log('异常')
          })
      },
      5000,
      { trailing: false }
    ),
    focusPasswordInput() {
      this.passwordError = false
    },
    inputBlur() {
      this.passwordError = !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/.test(this.password)
      if (this.passwordError) {
        this.passwordWarning = true
      } else {
        this.passwordWarning = false
      }
    },
    change() {
      if (this.password && this.confirmPassword) {
        this.canNext = true
      } else {
        this.canNext = false
      }
    },
    setPassword() {
      const $this = this
      this.passwordError = !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,16}$/.test(this.password)
      if (this.passwordError) {
        Toast({
          message: this.$t('loginAndRegister.pwdFormatToast')
        })
      } else {
        if (this.password === this.confirmPassword && !this.passwordError) {
          const params = {}
          params.password = md5(this.password)
          if (this.verifyType === 'EMAIL') {
            params.email = this.$store.state.userInfo.email
            params.updateType = 'EMAIL'
          } else {
            params.phone = this.$store.state.userInfo.phone
            params.updateType = 'PHONE'
          }
          params.securityToken = this.$store.state.securityToken
          params.userId = this.$store.state.userInfo.userId
          params.msgCode = this.smsCode
          let url = this.verifyType === 'EMAIL' ? '/api/auth/limitResetPasswordFormEmail' : '/api/auth/resetPassword'
          this.$http
            .post(window.serverPath + url, params)
            .then((res) => {
              if (res.data.code === '200') {
                this.popShow = false
                Toast.success({
                  message: this.$t('loginAndRegister.resetSuccessToast'),
                  onClose: function () {
                    localStorage.removeItem('token')
                    $this.$router.push({
                      name: 'beforeLogin'
                    })
                  }
                })
              } else if (res.data.code === '60005') {
                Toast({
                  message: this.$t('loginAndRegister.oldPwdErrorToast')
                })
              } else {
                Toast({
                  message: res.data.message
                })
              }
            })
            .catch((_err) => {
              console.log('异常')
            })
        } else {
          Toast({
            message: this.$t('paymentCode.inconsistentPasswordToast')
          })
        }
      }
    },
    closePopup() {
      this.popShow = false
    }
  }
}
</script>

<style scoped>
.set_payment_code_popup {
  padding: 0.24rem 0.2rem;
  background: #fff;
  border-radius: 0.16rem 0.16rem 0 0;
  position: relative;
}

.sub_container {
  width: 100%;
  height: 100%;
}

.slide_verification {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.title {
  display: flex;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.2rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.28rem;
  margin-bottom: 0.04rem;
  max-width: calc(100% - 0.4rem);
}

.account {
  display: flex;
  color: #3fbb70;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
  margin-bottom: 0.2rem;
  direction: ltr;
}

.send_span {
  color: #3fbb70;
  font-size: 0.14rem;
  font-family: 'PingFang SC';
  font-style: normal;
  font-weight: 400;
  line-height: 0.22rem;
  white-space: nowrap;
}

.send_span.disabled {
  color: #828282;
}

.next_btn {
  margin: 0.48rem auto 0.12rem;
  font-size: 0.16rem !important;
}

.switch_verify_type {
  width: 100%;
  text-align: center;
  margin-bottom: 0.24rem;
  color: #3fbb70;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
  line-height: 0.22rem;
}

.country_toast {
  width: 100%;
  display: flex;
  font-size: 0.12rem;
  font-weight: 400;
  color: #ff840b;
  margin: 0.06rem 0 0.12rem;
  align-items: center;
}

.note_icon {
  width: 0.12rem;
  height: 0.12rem;
  margin-inline-end: 0.02rem;
}

.password_status_icon {
  margin-inline-start: 0.2rem;
  width: 0.2rem;
  height: 0.2rem;
}

.pwd_input {
  margin-top: 0.12rem;
}

.close {
  position: absolute;
  top: 0.24rem;
  right: 0.24rem;
  width: 0.24rem;
  height: 0.24rem;
}

.close.mirror {
  left: 0.24rem;
  right: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Password/PasswordSetPopup.vue